var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-news"},[_c('span',{on:{"click":_vm.openFunZNX}},[_c('i',{staticClass:"fa fa-bell"}),_c('font',{class:_vm.hide})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }